/* eslint-disable import/prefer-default-export */
import { store } from 'store';

export const hasAccessAgentFeature = () => {
  const state = store.getState();
  const subscription = state?.companySubscription?.data;
  return subscription?.hasAI || false;
};
